import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "contacts-count" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "filters" }
const _hoisted_7 = ["aria-checked", "aria-disabled", "onKeydown"]
const _hoisted_8 = { class: "waitlist-toggle-control__left" }
const _hoisted_9 = {
  key: 0,
  class: "spinner"
}
const _hoisted_10 = {
  key: 1,
  class: "empty-block--wrapper"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "table-wrapper table-wrapper--waitlist scroll-wrapper"
}
const _hoisted_13 = { class: "table-default" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "bold" }
const _hoisted_16 = { class: "text-highlighted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title-main" }, "Waitlist", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(`${$setup.getContactsQuantity} Contact${$setup.getContactsQuantity > 1 ? "s" : ""} ${$setup.getLeadsQuantity} Lead${$setup.getLeadsQuantity > 1 ? "s" : ""}`), 1)
      ]),
      _createElementVNode("button", {
        class: "button default primary export-btn",
        onClick: $setup.exportWaitlist,
        disabled: $setup.isExportingWaitlist
      }, _toDisplayString($setup.isExportingWaitlist ? "Exporting..." : "Export Waitlist"), 9, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode($setup["InputSearch"], {
        modelValue: $setup.searchQuery,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
        placeholder: "Search",
        theme: "filter"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", {
        class: _normalizeClass(["waitlist-toggle-control", { 'waitlist-toggle-control--active': $setup.isWaitlistEnabled, 'waitlist-toggle-control--loading': $setup.togglingWaitlist }]),
        role: "switch",
        tabindex: "0",
        "aria-checked": $setup.isWaitlistEnabled,
        "aria-disabled": $setup.togglingWaitlist,
        "aria-label": "Toggle waitlist",
        onClick: $setup.toggleWaitlistIfReady,
        onKeydown: [
          _withKeys(_withModifiers($setup.toggleWaitlistIfReady, ["prevent"]), ["enter"]),
          _withKeys(_withModifiers($setup.toggleWaitlistIfReady, ["prevent"]), ["space"])
        ]
      }, [
        _createElementVNode("div", _hoisted_8, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "waitlist-toggle-control__label" }, "Waitlist", -1)),
          _createElementVNode("span", {
            class: _normalizeClass(["waitlist-toggle-control__badge", $setup.isWaitlistEnabled ? 'badge--active' : 'badge--inactive'])
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "waitlist-toggle-control__dot" }, null, -1)),
            _createTextVNode(_toDisplayString($setup.isWaitlistEnabled ? "Active" : "Inactive"), 1)
          ], 2)
        ]),
        _createVNode($setup["ToggleButton"], {
          modelValue: $setup.isWaitlistEnabled,
          disabled: $setup.togglingWaitlist,
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
          "onUpdate:modelValue": $setup.toggleWaitlist
        }, null, 8, ["modelValue", "disabled"])
      ], 42, _hoisted_7)
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9))
      : ($setup.waitlist.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("img", {
              class: "empty-block--icon",
              src: require('@/assets/icons/clock-slim.svg')
            }, null, 8, _hoisted_11),
            _cache[5] || (_cache[5] = _createElementVNode("p", null, "The waitlist for this estate is empty", -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("table", _hoisted_13, [
              _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "name" }, "Name"),
                  _createElementVNode("th", { class: "state" }, "Postcode"),
                  _createElementVNode("th", { class: "email" }, "Email"),
                  _createElementVNode("th", { class: "size" }, [
                    _createTextVNode("Lot size, m"),
                    _createElementVNode("sup", null, "2")
                  ]),
                  _createElementVNode("th", { class: "size" }, "Frontage, m"),
                  _createElementVNode("th", { class: "budget" }, "Budget")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.waitlist, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: idx,
                    onClick: ($event: any) => ($setup.handleRowClick(item))
                  }, [
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString($setup.getFullName(item?.customerId ? item?.customerId : item?.leadId)), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString($setup.getPostcode(item?.customerId ? item?.customerId : item?.leadId)), 1),
                    _createElementVNode("td", null, _toDisplayString(item?.customerId ? item?.customerId.email : item?.leadId.email), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.formatPrice(item?.lotSize?.from, false)) + " - " + _toDisplayString($setup.formatPrice(item?.lotSize?.to, false)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.formatPrice(item?.frontage?.from, false)) + " - " + _toDisplayString($setup.formatPrice(item?.frontage?.to, false)), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.formatPrice(item?.budget?.from)) + " - " + _toDisplayString($setup.formatPrice(item?.budget?.to)), 1)
                  ], 8, _hoisted_14))
                }), 128))
              ])
            ])
          ]))
  ]))
}